import React from 'react';
import { formatDate } from './Datepicker';

export function isRequired(value) {
    return value ? undefined : true;
}

export function isRequiredText(value) {
    return value ? undefined : <span className='error'>This field is required</span>;
}

export function isRequiredTextarea(value) {
    return value ? undefined : <span className='error textarea-error'>This field is required</span>;
}

export function isRequiredSelection(value) {
    return value ? undefined : <span className='error'>This selection is required</span>;
}

export function isRequiredStateSelection(value) {
    return value ? undefined : <span className='error state-selection'>This selection is required</span>;
}

export function isRequiredDate(value) {
    return value ? undefined : <span className='error'>This date is required</span>;
}

export function isRequiredSignatureDate(value) {
    if (formatDate(new Date()) !== formatDate(value)) {
        return <span className='error'>Please enter today's date and year.</span>;
    }
    return value ? undefined : <span className='error'>This date is required</span>;
}

export function isRequiredSignature(value) {
    return value ? undefined : <span className='error signature-error'>This signature is required</span>;
}

export function isRequiredSelectionCheckbox(value) {
    if (value && value.length === 0) {
        return <span className='error checkbox-error'>This selection is required</span>;
    }
    return value ? undefined : <span className='error checkbox-error'>This selection is required</span>;
}

export function isRequiredQuestionSelection(value) {
    return value ? undefined : <span className='error question-error'>This selection is required</span>;
}

export function isRequiredQuestionSelectionAlt(value) {
    return value ? undefined : <span className='error question-error'>A selection is required</span>;
}

export function validateEmail(value) {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (value) {
        return re.test(String(value).toLowerCase()) ? undefined : <span className='error'>Invalid email provided</span>;
    } else {
        return <span className='error'>Invalid email provided</span>;
    }
}

export function validateEmailSignup(value) {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (value) {
        return re.test(String(value).toLowerCase()) ? undefined : <span className='signup error'>Invalid email provided</span>;
    } else {
        return <span className='signup error'>Invalid email provided</span>;
    }
}

export function validateEmailCG(value) {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (value) {
        return re.test(String(value).toLowerCase()) ? true :false;
    } else {
        return false;
    }
}

export function isRequiredZipCode(value) {
    if (value) {
        var zipCode = /^\d{5}(-\d{4})?$/;
        return zipCode.test(value) ? undefined : <span className='error'> Invalid ZIP code provided</span>;
    } else {
        return <span className='error'>Invalid ZIP code provided</span>;
    }
}

export function isRequiredZipCodePAM(value) {
    if (value) {
        var zipCode = /^\d{5}(-\d{4})?$/;
        return zipCode.test(value) ? undefined : <span className='error'>Invalid ZIP code</span>;
    } else {
        return <span className='error'>Invalid ZIP code</span>;
    }
}

export function isRequiredPhoneNumber(value) {
    if (value) {
        var phoneNumberPattern = /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/;
        return phoneNumberPattern.test(value) ? undefined : <span className='error phone'>Invalid phone number provided</span>;
    } else {
        return <span className='error phone'>Invalid phone number provided</span>;
    }
}

// Verify input is number only
export function numberValidator(value) {
    const re = /^[0-9\b]+$/;
    return re.test(value);
}
export function conditionalNumberValidator(value, condition) {
    const re = /^[0-9\b]+$/;
    return condition ? re.test(value) : true;
}
export function conditionallyRequired(condition) {
    return condition ? isRequired : () => { };
}
export function conditionallyRequiredDate(condition) {
    return condition ? isRequiredDate : () => { };
};

export function conditionallyRequiredSignatureDate(condition) {
    return condition ? isRequiredSignatureDate : () => { };
};

export function conditionallyRequiredTextarea(condition) {
    return condition ? isRequiredTextarea : () => { };
};

export function conditionallyRequiredSelection(condition) {
    return condition ? isRequiredSelection : () => { };
};

export function conditionallyRequiredSelectionCheckbox(condition) {
    return condition ? isRequiredSelectionCheckbox : () => { };
};

export function conditionallyRequiredEmail(value, condition) {
    return condition ? validateEmail(value) : () => { };
};

export function conditionallyRequiredPhoneNumber(condition) {
    return condition ? isRequiredPhoneNumber : () => { };
};

export function conditionallyRequiredText(condition) {
    return condition ? isRequiredText : () => { };
}

export function conditionallyRequiredSignature(condition) {
    return condition ? isRequiredSignature : () => { };
};

export function falseValidation(condition) {
    return true;
};